import './NavBar.css';
import { Link, NavLink } from 'react-router-dom';
import Logo from "../../Photos/Icons/greenMain.png";
import EnrollIcon from "../../Photos/Enroll Now/send-2.png"
import FronLogo from "../../Photos/Icons/back.png"

const NavBar = ({ fullNav ,color}) => {

    const logo = {
        img : Logo,
        desc : "Scaleup Academy Logo"
    }
    const frontLogo = {
        img : FronLogo,
        desc : "Scaleup Academy Logo"
    }

    return (
        <div className="navigationbar">
            <div className="backgroundBlur"></div>
            <div  className="leftNav">
                {fullNav &&
                <div className='logo'>
                    <img src={frontLogo.img} alt={frontLogo.desc} />
                    <img src={logo.img} alt={logo.desc}/>
                </div>
                    
                }

            </div>
            <div  className="middleNav">
                <div style={{ backgroundColor: color ? '#10231191' : '' }} className="Links">
                    <NavLink to="/" className={({ isActive }) => isActive ? "active noScroll" : "scrollLinkNav"}>
                        <span>Home</span>
                        <span>Home</span>
                    </NavLink>
                    <NavLink to="/about" className={({ isActive }) => isActive ? "active noScroll" : "scrollLinkNav"}>
                        <span>About us</span>
                        <span>About us</span>
                    </NavLink>
                    <NavLink to="/courses" className={({ isActive }) => isActive ? "active noScroll" : "scrollLinkNav"}>
                        <span>Courses</span>
                        <span>Courses</span>
                    </NavLink>
                    <NavLink to="/contact" className={({ isActive }) => isActive ? "active noScroll" : " scrollLinkNav"}>
                        <span>Contact</span>
                        <span>Contact</span>
                    </NavLink>

                    {/* {fullNav === false &&
                        <Link className='middleNavEnroll' to={"/contact"}>
                            <img src={EnrollIcon} alt='enrollNow' />Enroll Now
                        </Link>
                    } */}

                    </div>
                </div>
                <div className="rightNav">
                    {fullNav &&
                        <div className="EnrollNow">
                            <a href='/contact/enrollNow' aria-label="Enroll now in ScaleUp Academy courses" to={"/contact/enrollNow"}> <img src={EnrollIcon} alt='Enroll Now Scaleup Academy Courses' /> <p>Enroll Now</p></a>
                        </div>
                    }

                </div>
            </div>
            );
};

            export default NavBar;

